import {
  CONCAT_TEXT_LIMIT,
  HEADER_TAB_SETUP,
  KEY_GENERATOR,
} from "../../functions/funtion";
import {
  PT_MASTERCATEGORY,
  PT_PRODUCT_LIST,
  PT_HOME,
} from "../../routes/stack/paths/pt-home";
import {
  STORE_MERCHANT_SCROLL,
  STORE_MERCHANT,
} from "../../database/store-names";
import { api_LoadMerchantsToMobileAppCategory } from "../../connection/api/api-home";
import { dto_MobileAppCategory } from "../../classes/dto-mobile-app-category";
import { set_dto_Merchant } from "../../classes/dto-setters/dto-setter";
import { ENCRYPT_STORAGE } from "../../config/config";
import MerchantCard from "./components/merchant-card/merchant-card";
import React from "react";

export default class CategoryWiseMerchant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      MerchantData: [],
      Filteredmerchants: [],
      IsLoading: false,
      noItem: false,
    };
  }

  async componentDidMount() {
    let merchant = ENCRYPT_STORAGE.getItem(STORE_MERCHANT);
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: dto_MobileAppCategory.MobileAppCategory,
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_HOME);
      },
      HeaderNavigatorMenuDisplay: false,
      FnHeaderNavigatorMenu: () => {},
    });

    if (merchant !== undefined) {
      this.setState({ MerchantData: merchant });
      if (merchant.length === 1) {
        merchant[0].CATID = 0;
        await set_dto_Merchant(merchant[0]);
        if (merchant[0].MT === "RS") {
          this.props.navigate(
            PT_PRODUCT_LIST.replace(":navPage", "none").replace(
              ":isSec",
              "false"
            )
          );
        } else {
          this.props.navigate(PT_MASTERCATEGORY);
        }
      } else {
        await this.LoadProductToMobileAppCategory();
      }
    }
  }

  async LoadProductToMobileAppCategory() {
    this.setState({ IsLoading: true });
    let data = await api_LoadMerchantsToMobileAppCategory();
    let d = JSON.parse(data);
    let x = this.state.MerchantData;
    let rs = x.filter(function (obj) {
      return d.some(function (obj2) {
        return obj.MID === obj2.Key;
      });
    });
    this.setState({ IsLoading: false, Filteredmerchants: rs });
    if (rs.length === 0) {
      this.setState({ noItem: true });
    }
  }

  render() {
    return (
      <div style={{ marginTop: 55, marginBottom: 55 }}>
        {this.state.IsLoading ? (
          <div
            className="loader"
            style={{ marginTop: "90%", marginLeft: "45%" }}
          />
        ) : (
          <div>
            {this.state.noItem ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={require("./images/NoDataFound.jpg")}
                  width={"60%"}
                  alt=""
                />

                <label
                  style={{
                    fontWeight: "bold",
                    marginBottom: "22px",
                    textAlign: "center",
                  }}
                >
                  No Merchants Found
                </label>
                <label
                  style={{
                    textAlign: "center",
                    display: "block",
                  }}
                >
                  Try browsing a different category
                </label>
              </div>
            ) : (
              <>
                {this.state.Filteredmerchants.map((rs) => {
                  return (
                    <MerchantCard
                      data={rs}
                      key={KEY_GENERATOR()}
                      navigate={this.props.navigate}
                      onScroll={() => {
                        const scrollIndex = rs.MID + "MerchantCard";
                        ENCRYPT_STORAGE.setItem(
                          STORE_MERCHANT_SCROLL,
                          scrollIndex
                        );
                      }}
                    />
                  );
                })}
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}
